import { useState } from "react";
import MuseSteps from "./MuseSteps";
import VolumeStep from "./VolumeStep";
import SetupScreen from "./SetupScreen";
import { EducationalProps } from "../../types/interfaces";
import { GenderType, MuseScreenStep, SectionType } from "../../utils/enums";

const EducationalStepsWrapper = ({ sections, gender, onComplete, isCustom, startStep }: EducationalProps) => {
	const [step, setStep] = useState(startStep ?? 1);

	switch (step) {
		case 1:
			return (
				<MuseSteps
					applicableScreens={
						sections?.[0] === SectionType.Full || !sections || !sections?.length
							? undefined
							: sections[0] === SectionType.Body
							? [MuseScreenStep.Body, MuseScreenStep.SizeFit, MuseScreenStep.Ready]
							: [MuseScreenStep.Face, MuseScreenStep.SizeFit]
					}
					isCustom={isCustom}
					gender={gender || GenderType.Male}
					onNext={() => setStep(2)}
				/>
			);

		case 2:
			return <VolumeStep onNext={() => (sections?.[0] === SectionType.Face ? onComplete?.() : setStep(3))} />;

		case 3:
			return <SetupScreen gender={gender || GenderType.Male} onNext={onComplete} />;

		default:
			return <></>;
	}
};

export default EducationalStepsWrapper;
